import debounce from 'lodash/debounce'
import ossUploadImg from '../oss/oss-upload-img'
import userSetting from "./user-setting.vue"
import uploadImg from "../../../components/uploadImg"
import taskSub from "./taskSub"
import { isEmail } from "../../../utils/validate";
import contractDetail from "./contractDetail"
import Cookies from 'js-cookie'
export default {
	props:['userId','fkbShow'],
    components: {
		ossUploadImg,userSetting,taskSub,uploadImg
		,contractDetail
    },
	data () {
		return {
			isStatusDis:false,//数据 是否可编辑
			fileList:[],//公司照片
			fileList1:[],//工作场景
			fileidcardFacePath:[],//法人身份证正面
			fileidcardBackPath:[],//法人身份证反面
			fileclientIdcardFacePath:[],//委托人
			fileclientIdcardBackPath:[],//委托人
			filepowerofAttorney:[],//委托书
			settintUserList:[],//开票项目列表
			bodyInfo:[],//税源地列表
			// dlsList:[],//代理商列表
			isEditBtn:true,//已审核增加修改功能
			isPayChannel:`${Cookies.get('admin_role')}`,
			payChannel:[
				// {value:0,label:'招商银行'},
				{value:1,label:'支付宝'},
				// {value:2,label:'平安银行'}
				{value:3,label:'招商银行灵账'},
			],
			multiple: false,
			url: `${window.SITE_CONFIG['apiURL']}/oss/file/upload2?access_token=${Cookies.get('access_token')}`,
			tip: '企业营业执照照片',
			tip1: '身份证正面照',
			tip2: '身份证反面照',
			visible: true,
			dialogImageUrl:'',
			dialogVisible:false,
			isLegalList:[
				{label:'法人',value:1},
				{label:'委托人',value:0},
			],
			// 企业基本信息
			dataForm: {
				idcardFacePath:'',//法人身份证正面
				idcardBackPath:'',//法人身份证反面
				clientIdcardFacePath:'',//委托书
				clientIdcardBackPath:'',//委托人身份证正面
				powerofAttorney:'',//委托人身份证反面
				isLegal:1,//1法人0委托人
				caBodyDTOS:[],//多税源地列表
				companyPhoto:'',//公司照片
				workScenePhoto:'',//工作场景
				licensePath:'',//营业执照
				username:'',//用户名
				realName:'',//姓名
				mobile:'',//手机号
				email:'',//邮箱
				bodyId:'',//税源地
				caName:'',//企业名称
				taxCode:'',//税号
				legalPersonName:'',//法人姓名
				legalPersonIdcard:'',//法人身份证
				bankName:'',//开户行
				bankAccount:'',//银行账号
				address:'',//注册地址
				phone:'',//注册电话
				taxAddress:'',//联系地址
				contacts:'',//联系人
				businessScope:'',//经营范围
				hasLaborDispute:'',//企业劳动纠纷
				hasTaxAnomaly:'',//税务异常
				hasIcAnomaly:'',//工商异常
				isDishonest:'',//法人是否被执行
				payFee:'',//服务费率
				ticketType:'',//发票类型
				serviceFeeType:'',//服务费承担方
				serviceFeeType1:[],//服务费承担方
				processList:[],
				caStatus:''
			},
		}
    },
    computed: {
		dataRule () {
			var validateName = (rule, value, callback) => {
				if(!value){ callback('必填项不能为空') } callback()
			}
			var checkNumtwo = (rule, value, callback) => {
				if (/^[0-9a-zA-Z]{7,20}$/.test(value)) {
					callback()
				} else {
					callback(new Error('请输入正整数'))
				}
			}
			var checknum = (rule, value, callback) => {
				if (!isNumber(value)) {
					callback(new Error('请输入数字值'))
				}
				callback()
			}
			var checkfloat = (rule, value, callback) => {
				if (/^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/.test(value)) {
					callback()
				} else {
					callback(new Error('请输入数字值,并且最多两位小数'))
				}
			}
			var checkphone = (rule, value, callback) => {
				if (/^1\d{10}$/.test(value)) {
					callback()
				} else if (/^0\d{2,3}-?\d{7,8}$/.test(value)) {
					callback()
				} else {
					callback(new Error('请输入手机号'))
				}
			}
			var checkcard = (rule, value, callback) => {
				if (/^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/
					.test(value)) {
					callback()
				} else {
					callback(new Error('请输入身份证号'))
				}
			}
			var checkbank = (rule, value, callback) => {
				if(/^\d{1,30}$/.test(value) ){
					callback()
				} else {
					callback(new Error('请输入卡号'))
				}
			}
			var checkPayFrr = (rule, value, callback) => {
				let reg = /^\d+(\.\d{1,2})?$/;
				if (reg.test(value)&&parseFloat(value)<=100) {
				callback()
				} else {
				callback(new Error('请输入小于等于100的数字,最大保留两位小数'))
				}
			}
			var checkbankCode = (rule, value, callback) => {
				if(value == ''){
					callback(new Error('请输入银行行号信息'))
				}else if(/[^\d]/.test(value)) {
					callback(new Error('只能输入数字'))
				} else {
					callback()
				}
			}
			var validateEmail = (rule, value, callback) => {
				if (!isEmail(value)) {
					callback(new Error('请输入正确的邮箱'))
				}
				callback()
			}
			return {
				companyPhoto:[{required: true,message: this.$t('validate.required'),trigger: 'blur'}],
				workScenePhoto:[{required: true,message: this.$t('validate.required'),trigger: 'blur'}],
				username:[{required: true,message: this.$t('validate.required'),trigger: 'blur'}],
				realName:[{required: true,message: this.$t('validate.required'),trigger: 'blur'}],
				mobile:[{required: true,message: '输入正确的手机号',validator: checkphone,trigger: 'blur'}],
				email:[{required: true,message: '请输入正确的邮箱',validator: validateEmail,trigger: 'blur'}],
				legalPersonIdcard: [{required: false,message: '请输入身份证号',validator: checkcard,trigger: 'blur'}],
				legalPersonName: [{required: false,message: this.$t('validate.required'),trigger: 'blur'}],
				businessScope: [{required: true,message: this.$t('validate.required'),trigger: 'blur'}],
				caName: [{required: true,validator:validateName,trigger: 'blur'}],
				taxCode: [{required: true,message: '格式错误，7-20位数字或字母',validator: checkNumtwo,trigger: 'blur'}],
				bankName: [{required: true,message: this.$t('validate.required'),trigger: 'blur'}],
				bankAccount: [{required: true,message: '请输入卡号',trigger: 'blur'},{ message: '银行卡号错误，请检查位数',validator: checkbank,trigger: 'blur'}],
				address: [{required: true,message: this.$t('validate.required'),trigger: 'blur'}],
				contacts: [{required: true,message: this.$t('validate.required'),trigger: 'blur'}],
				phone: [{required: true,message: '输入正确的电话号码',validator: checkphone,trigger: 'blur'}],
				licensePath: [{required: true,message: this.$t('validate.required'),trigger: 'blur'}],
				taxAddress: [{required: true,message: this.$t('validate.required'),trigger: 'blur'}],
				hasLaborDispute:[{required: true,message: this.$t('validate.required'),trigger: 'change'}],
				hasTaxAnomaly:[{required: true,message: this.$t('validate.required'),trigger: 'change'}],
				hasIcAnomaly:[{required: true,message: this.$t('validate.required'),trigger: 'change'}],
				isDishonest:[{required: true,message: this.$t('validate.required'),trigger: 'change'}],
				payFee:[{required: true,message: this.$t('validate.required'),trigger: 'blur'},{message:'请输入正确的税率',validator: checkPayFrr,trigger: 'blur'}],
				ticketType:[{required: true,message: this.$t('validate.required'),trigger: 'change'}],
				serviceFeeType1:[{required: true,message: this.$t('validate.required'),trigger: 'change'}],
				bodyIds:[{required: true,message: this.$t('validate.required'),trigger: 'change'}],
				isLegal:[{required: false,message: this.$t('validate.required'),trigger: 'change'}],
				idcardFacePath:[{required: false,message: this.$t('validate.required'),trigger: 'change'}],
				idcardBackPath:[{required: false,message: this.$t('validate.required'),trigger: 'change'}],
				clientIdcardFacePath:[{required: false,message: this.$t('validate.required'),trigger: 'change'}],
				clientIdcardBackPath:[{required: false,message: this.$t('validate.required'),trigger: 'change'}],
				powerofAttorney:[{required: false,message: this.$t('validate.required'),trigger: 'change'}],
			}
		}
    },
    created () {
		// 默认通过用户列表进去    userId为prop传参为企业用户登录进入
		this.dataForm.userId = this.$route.params.id || this.userId || ''
		this.dataForm.caStatus = this.$route.params.caStatus || '1'
		this.dataForm.addContract = this.$route.params.addContract || false
		this.dataForm.isEdit = this.$route.params.isEdit || false
		// 获取税源地列表
		this.$http.get(`/sys/plat/body/page?order=&orderField=&page=1&limit=1000&sydEdit=1`).then(({ data: res }) => {
			this.bodyInfo = res.data.list
			// this.bodyInfo = res.data.list.filter(item => item.id != '1453241566079012865');
		})
		if(this.dataForm.userId){
			this.getInfo()
		}
    },
	watch:{
		fileList(newVal,oldVal){
			if(newVal.length > 0){
				this.dataForm.companyPhoto = newVal.map((item) => {
					return item.url
				}).join(',')
			}else{
				this.dataForm.companyPhoto = ''
			}
		},
		fileList1(newVal,oldVal){
			if(newVal.length > 0){
				this.dataForm.workScenePhoto = newVal.map((item) => {
					return item.url
				}).join(',')
			}else{
				this.dataForm.workScenePhoto = ''
			}
		},
		fileidcardFacePath(newVal,oldVal){
			if(newVal.length >0){
				this.dataForm.idcardFacePath = newVal.map((item) => {
					return item.url
				}).join(',')
			}else{
				this.dataForm.idcardFacePath = ''
			}
		},
		fileidcardBackPath(newVal,oldVal){
			if(newVal.length >0){
				this.dataForm.idcardBackPath = newVal.map((item) => {
					return item.url
				}).join(',')
			}else{
				this.dataForm.idcardBackPath = ''
			}
		},
		fileclientIdcardFacePath(newVal,oldVal){
			if(newVal.length >0){
				this.dataForm.clientIdcardFacePath = newVal.map((item) => {
					return item.url
				}).join(',')
			}else{
				this.dataForm.clientIdcardFacePath = ''
			}
		},
		fileclientIdcardBackPath(newVal,oldVal){
			if(newVal.length >0){
				this.dataForm.clientIdcardBackPath = newVal.map((item) => {
					return item.url
				}).join(',')
			}else{
				this.dataForm.clientIdcardBackPath = ''
			}
		},
		filepowerofAttorney(newVal,oldVal){
			if(newVal.length >0){
				console.log(newVal)
				this.dataForm.powerOfAttorney = newVal.map((item) => {
					return item.url
				}).join(',')
				this.dataForm.powerOfAttorneyName = newVal[0].fileName + '.' +newVal[0].fileType
			}else{
				this.dataForm.powerOfAttorney = ''
			}
		},
	},
    methods: {
		updateForm(val,index,taskIndex){
			this.$set(this.dataForm.caBodyDTOS[index].taskTypes[taskIndex],'businessScenario',val.businessScenario)
			this.$set(this.dataForm.caBodyDTOS[index].taskTypes[taskIndex],'monthlyVolume',val.monthlyVolume)
			this.$set(this.dataForm.caBodyDTOS[index].taskTypes[taskIndex],'taskRequire',val.taskRequire)
		},
		// 税源地切换
		bodyIdChange(e){
			const oldBody = this.dataForm.caBodyDTOS.length > 0 ? JSON.parse(JSON.stringify(this.dataForm.caBodyDTOS)) : [];
			console.log(oldBody)
			e.map((item,index) => {
					item.bodyId = item.id
					item.payFee = ''
					item.serviceFeeType1 = []
					item.taskTypes = []
			})
			this.dataForm.caBodyDTOS = this.dataForm.bodyId
			this.dataForm.caBodyDTOS.map((item,index) => {
				oldBody.map((oldItem,oldIndex) => {
					if(item.id == oldItem.bodyId){
						let index_n = this.dataForm.caBodyDTOS.indexOf(item)
						this.$set(this.dataForm.caBodyDTOS[index_n],'payFee',oldItem.payFee)
						this.$set(this.dataForm.caBodyDTOS[index_n],'serviceFeeType1',oldItem.serviceFeeType1)
						this.$set(this.dataForm.caBodyDTOS[index_n],'taskTypes',oldItem.taskTypes ? oldItem.taskTypes : [])
					}
				})
			})
		},
        //图片上传
        getGsimg(list){
            this.fileList = list;
        },
        delGsImg(list){
            this.fileList = list;
        },
        getCjimg(list){
            this.fileList1 = list;
        },
        delCjImg(list){
            this.fileList1 = list;
        },
        // 设置开票项目
        // handleSetting(){
        //     this.$refs.userSetting.init();
        // },
		// 设置开票项目
        handleSetting(item){
			this.settintUserList = item.taskTypes ? item.taskTypes : []
            this.$refs.userSetting.init(item);
        },
        // handleUserList(item){
        //     this.settintUserList = item;
        //     this.$refs.dataForm.validateField('settintUserList');
        // },
		handleUserList(item,parentItem){
			item.map((newObj,index) => {
				let objData = {};
				this.settintUserList.map((oldObj,index) => {
					if(newObj.ticketProId == oldObj.ticketProId){
						objData = {...newObj,monthlyVolume:oldObj.monthlyVolume,businessScenario:oldObj.businessScenario,taskRequire:oldObj.taskRequire,id:oldObj.id}
					}else{
						objData = newObj
					}
				})
				newObj == objData
			})
            this.settintUserList = item;
            this.$refs.dataForm.validateField('settintUserList');
			this.dataForm.caBodyDTOS.map((bodyItem,index) => {
				if(bodyItem.bodyId == parentItem.bodyId){
					bodyItem.taskTypes = item;
				}
			})
        },
		// 已审核增加修改保存功能
		editHandle(){
			if(this.isEditBtn){//修改编辑功能
				this.isEditBtn = false;
			}else{//保存功能
				this.dataFormSubmitHandle(1);
			}
		},
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file;
			this.dialogVisible = true;
		},
		// 上传之前
		beforeUploadHandle (file) {
			if (file.type !== 'image/jpg' && file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/gif') {
				this.$message.error(this.$t('upload.tip', {
					'format': 'jpg、png、gif'
				}))
				return false
			}
			if (file.size / 1024 / 1024 > 30) {
				this.$message.error('文件太大，只能上传30MB以内的文件')
				return false
			}
		},
		//营业执照识别
		licensePathsuccessHandle (data, file) {
			this.dataForm.licensePath = data.data.url
			let imgUrl = data.data.url;
			this.$http.post('/sys/plat/info/ca/bizLicenseOcr',{imageUrl:imgUrl}).then(({ data: res })=>{
				if(res.code == 0){
					let LicenseInfo = res.data,
						formInfo = this.dataForm;
						//经营范围
						formInfo.businessScope = LicenseInfo.business
						//企业名称
						formInfo.caName = LicenseInfo.name
						//社会信用代码
						formInfo.taxCode = LicenseInfo.regNum
						//注册地址
						formInfo.address = LicenseInfo.address
						//法人姓名
						formInfo.legalPersonName = LicenseInfo.person
				}
			})
		},
		getInfo () {
			
			// 获取代理商
			// this.$http.get(`sys//plat/info/ca/getAgentList`,{}).then((res) => {
			// 	if(res.code != 0){
			// 		this.dlsList = res.data.data
			// 	}
			// })
			// 获取用户基本信息
			this.$http.get(`/sys/user/getInfoById?id=` + this.dataForm.userId).then(({
				data: res
			}) => {
				if (res.code !== 0) {
					return this.$message.error(res.msg)
				}
				this.dataForm = {
					...this.dataForm,
					...res.data
				}
				console.log(this.dataForm)
				this.fileList = this.dataForm.companyPhoto != '' > 0 ? this.dataForm.companyPhoto.split(",").map((item,index) => {
					let obj = {url:item};
					return obj
				}): []
				this.fileList1 = this.dataForm.workScenePhoto != '' > 0 ? this.dataForm.workScenePhoto.split(",").map((item,index) => {
					let obj = {url:item};
					return obj
				}) : []
				// this.settintUserList = this.dataForm.taskTypes ? this.dataForm.taskTypes : []
				// this.dataForm.serviceFeeType1 = this.dataForm.serviceFeeType ? this.dataForm.serviceFeeType.split(',') : []
				// console.log(this.dataForm)
				// 身份证附件
				this.fileidcardBackPath = this.dataForm.idcardBackPath ? this.dataForm.idcardBackPath.split(",").map((item,index) => {
					let obj = {url:item};
					return obj
				}) : []
				this.fileidcardFacePath = this.dataForm.idcardFacePath ? this.dataForm.idcardFacePath.split(",").map((item,index) => {
					let obj = {url:item};
					return obj
				}) : []
				this.fileclientIdcardFacePath = this.dataForm.clientIdcardFacePath ? this.dataForm.clientIdcardFacePath.split(",").map((item,index) => {
					let obj = {url:item};
					return obj
				}) : []
				this.fileclientIdcardBackPath = this.dataForm.clientIdcardBackPath ? this.dataForm.clientIdcardBackPath.split(",").map((item,index) => {
					let obj = {url:item};
					return obj
				}) : []
				this.filepowerofAttorney = this.dataForm.powerOfAttorney ? this.dataForm.powerOfAttorney.split(",").map((item,index) => {
					let obj = {url:item,name:this.dataForm.powerOfAttorneyName || '授权委托书'};
					return obj
				}) : []
				this.isStatusDis = true
				//判断是否选择税源地
				if(this.dataForm.caBodyDTOS.length > 0){
					// 多税源地服务费承担方格式化
					this.dataForm.caBodyDTOS.map((item,index) => {
						item.serviceFeeType1 = item.serviceFeeType ? item.serviceFeeType.split(',') : []
					})
					// 初始化多税源地下拉
					let newSyd = [];
					this.bodyInfo.map((item,index) => {
						this.dataForm.caBodyDTOS.map((bodyItem,bodyIndex) => {
							if(item.id == bodyItem.bodyId){
								newSyd.push(item)
							}
						})
					})
					this.dataForm.bodyId = newSyd
				}
				// this.isStatusDis = this.dataForm.caStatus > 1 ? true : false
				// this.isStatusDis = this.fkbShow ? true : false
				// this.isStatusDis = this.dataForm.caStatus > 1 ? true : false
			}).catch(() => {})

			// // 获取用户合同信息
			// this.$http.get(`/sys/plat/contract/get?id=` + this.dataForm.userId).then(({
			// 	data: res
			// }) => {
			// 	console.log(res)
			// })
			
		},
		// 表单提交
		dataFormSubmitHandle: debounce(function (inStatus) {
			console.log(this.dataForm)
			console.log(inStatus)

			// 处理服务承担方数据
			this.dataForm.serviceFeeType = this.dataForm.serviceFeeType1.length > 0 ? this.dataForm.serviceFeeType1.join(',') : ''
			// 配置开票项目数据处理
			console.log(this.dataForm)
			// 保存和录入用户直接保存（只校验用户名和企业名称）
			if(inStatus == 0){
				if(this.settintUserList.length > 0){
					this.$refs.taskSub.map((item,index) => {
						this.settintUserList[index] = {
							...this.settintUserList[index],
							...item.dataForm
						}
					})
				}else{
					this.settintUserList = []
				}
				this.dataForm.taskTypes = this.settintUserList;
				let addArr = [];
				this.$refs.dataForm.validateField(['username','caName'],(err) => {
					addArr.push(err)
				})
				console.log(addArr)
				if(!addArr.includes('必填项不能为空'))  this.handleSubmit(0);
				return false
			}
				this.$refs['dataForm'].validate(valid => {
					if (!valid) {
						return false
					}
					// if(this.settintUserList.length == 0){
					// 	return this.$message.error('请设置开票项目!')
					// }
					const taskSubLength = []
					if(this.settintUserList.length > 0){
						this.$refs.taskSub.map((item,index) => {
							console.log(this.$refs.taskSub[index].$refs['dataForm'])
							this.$refs.taskSub[index].$refs['dataForm'].validate(valid => {
								if (!valid) {
									return false
								}else{
									taskSubLength.push(1)
								}
							})
							this.settintUserList[index] = {
								...this.settintUserList[index],
								...item.dataForm
							}
						})
					}else{
						this.settintUserList = []
					}
					
					this.dataForm.taskTypes = this.settintUserList;
					if(taskSubLength.length != this.settintUserList.length){
						return false
					}
					this.dataForm.caStatus = inStatus;
					this.handleSubmit(inStatus)
				})
			},1000, {
				leading: true,
				trailing: false
			}
		),
		// 数据提交
		handleSubmit(caStatus){
			let url = this.dataForm.id ? '/sys/plat/info/ca/updateByAgent' : '/sys/plat/info/ca/createByAgent';
			this.$http.post(url, {...this.dataForm,caStatus:caStatus}).then(({
				data: res
			}) => {
				if (res.code !== 0) {
					this.dataForm.caStatus = 1
					return this.$message.error(res.msg)
				}
				this.$message({
					message: this.$t('prompt.success'),
					type: 'success',
					duration: 500,
					onClose: () => {
						// this.dataForm.userId = this.$route.params.id || ''
						// this.dataForm.caStatus = this.$route.params.caStatus || '1'
						// this.getInfo()
						this.$router.go(-1)
					}
				})
				this.isEditBtn = true;
			})
			.catch(() => {})
		},
		yulan (url) {
			window.open(url, url)
		},
		delPicUrl(key){
			this.dataForm[key] = '';
		},
		dataFormStatusHandle: debounce(function (inStatus, id) {
			let _this = this
			this.$prompt('请输入审核理由', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消'
			}).then(({
					value
				}) => {
					if(inStatus == 0 && !value){
						return this.$message.error('请输入驳回原因！');
					}
				let pass = inStatus == 1 ? 'pass' : 'return'
				this.$http.post('/sys/plat/info/ca/auditBody', {
						userId: id,
						result: pass,
						reason: value,
						agentId:this.dataForm.agentId
					}, {
						headers: {
						'content-type': 'application/json;charset=utf-8'
						}
				}).then(({
					data: res
				}) => {
					if (res.code !== 0) {
						return this.$message.error(res.msg)
					}
					// if(inStatus == 1){
					// 	this.dataFormSubmitHandle(0)
					// }
					this.$message({
						message: this.$t('prompt.success'),
						type: 'success',
						duration: 500,
						onClose: () => {
								// this.getInfo()
							this.$router.go(-1)
						}
					})
				}).catch(() => {})
			})
		}),
		// 合同审核
		handleContractStatus:debounce(function (inStatus,id) {
			let _this = this
			this.$prompt('请输入审核理由', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消'
			}).then(({
				value
			}) => {
				if(inStatus == 0 && !value){
					return this.$message.error('请输入驳回原因！');
				}
				// this.$http.post('/sys/plat/contract/audit?inStatus=' + inStatus + '&content=' + value + '&id=' + this.$refs.contractDetail.dataForm.id, {
			this.$http.post('/sys/plat/contract/batchAudit',{
				inStatus:inStatus,
				userId:id,
				content:value
			},{
				headers: {'content-type': 'application/x-www-form-urlencoded'}
			}).then(({
				data: res
				}) => {
				if (res.code !== 0) {
					return this.$message.error(res.msg)
				}
				this.$message({
					message: this.$t('prompt.success'),
					type: 'success',
					duration: 500,
					onClose: () => {
					this.$router.back(-1)
					}
				})
				}).catch(() => {})
			})
		})
    }
  }